export const programming = [
  {
    id: 1,
    lang: "HTML + CSS / SASS",
  },
  {
    id: 2,
    lang: "JavaScript + TypeScript",
  },
  {
    id: 3,
    lang: "React + Redux",
  },

  {
    id: 4,
    lang: "Gatsby",
  },

  {
    id: 5,
    lang: "Firebase",
  },
  {
    id: 6,
    lang: "Bootstrap",
  },
  {
    id: 7,
    lang: "C / C++",
  },

  {
    id: 8,
    lang: "PHP + MySQL",
  },
];


export const tools = [
  {
    id:0,
    tool:'ChatGPT',
  },
  {
    id: 1,
    tool: "NPM",
  },
  {
    id: 2,
    tool: "Git & Github",
  },
  {
    id:3,
    tool: 'Jira',
  },
  {
    id:4,
    tool:'Postman',
  },
  {
    id: 5,
    tool: "Contentful",
  },
  {
    id: 6,
    tool: "Wordpress Development",
  },
  {
    id: 7,
    tool: "Figma",
  },
  {
    id: 8,
    tool: "Photopea",
  },
  
  {
    id: 9,
    tool: "Canva",
  },
  {
    id: 10,
    tool: "Adobe Premiere Pro",
  },
];
